module.exports = __webpack_public_path__ + "static/img/4088_phase_function_Paper_PointsHejduk_Prediction.46f6472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4088_phase_function_Paper_PointsHejduk_Prediction.png
// module id = RD8Z
// module chunks = 0